<!-- WHAT'S NEW SECTION - STARTS -->
<section class="whats-new bg-marquee">
    <div class="container-xxl">
        <div class="whats-new-area my-3">
            <div class="title"><a href="" [attr.title]="language=='English'?'Go to Whats New':'नया क्या है पर जाएँ'" class="screen-reader" routerLink="../whatsnewdetails">{{'WhatsNews' | translate }}</a></div>
            <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();">
                <ul class="d-flex align-items-center px-2 mx-3 mb-0" >
                    <ng-container *ngFor="let item of whatsnewDetails">
                        <li class="me-4">
                            <div [ngSwitch]="item.VCHTYPE">
                                 <div *ngSwitchCase="3">
                                    <a class="screen-reader" (click)="viewDetails(item.NewsId, 'news')">{{language == 'English' ?  item.NewsTitle : item.NewsTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="4">
                                    <li class="me-4">
                                    <a class="screen-reader" (click)="viewDetails(item.PressId, 'pressreleasedetails')">{{language == 'English' ?  item.PressTitle : item.PressTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="7">
                                    <li class="me-4">
                                    <a class="screen-reader" (click)="viewDetails(item.AwrdId, 'awarddetails')">{{language == 'English' ?  item.AwrdTitle : item.AwrdTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="6">
                                    <li class="me-4">
                                    <a class="screen-reader" (click)="viewDetails(item.CirId, 'circulardetails')">{{language == 'English' ?  item.CirTitle : item.CirTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="8">
                                    <li class="me-4">
                                    <a class="screen-reader" (click)='goToExtLink(item.url)'>{{language == 'English' ?  item.Rectitle : item.RectitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="2">
                                    <li class="me-4">
                                        <a class="screen-reader" (click)="viewDetails(item.tenderId, 'tender-details')">{{language == 'English' ?  item.TenderTitle : item.TendertitleHN }}</a>
                                   </div>

                            </div>
                        </li>             
                    </ng-container>
                </ul>
            </marquee>
        </div>
    </div>
</section>
<!-- WHAT'S NEW SECTION - ENDS -->


<!-- OMSS SECTION - STARTS -->
<section class="omss">
    <div class="container-xxl">

        <div class="omss-area my-3">
            <div class="title"><a href="javascript:void();" class="screen-reader">{{'omss' | translate }}</a></div>
            <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();">
                <ul class="d-flex align-items-center px-2 mx-3 mb-0" >
                    <ng-container *ngFor="let item of omssDetails">
                        <li class="me-4">
                            <div [ngSwitch]="item.VCHTYPE">
                                 <div *ngSwitchCase="3">
                                    <a (click)="viewDetails(item.NewsId, 'news')" class="screen-reader">{{language == 'English' ?  item.NewsTitle : item.NewsTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="4">
                                    <li class="me-4">
                                    <a (click)="viewDetails(item.PressId, 'pressreleasedetails')"  class="screen-reader">{{language == 'English' ?  item.PressTitle : item.PressTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="7">
                                    <li class="me-4">
                                        
                                    <a (click)="viewDetails(item.AwrdId, 'awarddetails')" class="screen-reader" >{{language == 'English' ?  item.AwrdTitle : item.AwrdTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="6">
                                    <li class="me-4">
                                      
                                    <a (click)="viewDetails(item.CirId, 'circulardetails')" class="screen-reader" >{{language == 'English' ?  item.CirTitle : item.CirTitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="8">
                                    <li class="me-4">
                                      
                                    <a (click)='goToExtLink(item.url)' class="screen-reader" >{{language == 'English' ?  item.Rectitle : item.RectitleHN }}</a>
                                   </div>

                                   <div *ngSwitchCase="2">
                                    <li class="me-4">                                        
                                        <a (click)="viewDetails(item.tenderId, 'tender-details')" class="screen-reader" >{{language == 'English' ?  item.TenderTitle : item.TendertitleHN }}</a>
                                   </div>

                            </div>
                        </li>             
                    </ng-container>
                </ul>
            </marquee>

        </div>
    </div>
</section>
<!-- OMSS SECTION - ENDS -->